import { render } from "./TurnstileChallenge.vue?vue&type=template&id=2484d543&scoped=true"
import script from "./TurnstileChallenge.vue?vue&type=script&lang=ts"
export * from "./TurnstileChallenge.vue?vue&type=script&lang=ts"

import "./TurnstileChallenge.vue?vue&type=style&index=0&id=2484d543&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2484d543"

export default script